import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

export default function FaqAdminList() {
  const navigate = useNavigate();
  const [topics, setTopics] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchFaqs = async () => {
    setLoading(true);
    try {
      const res = await api.get("/admin/faqs");
      setTopics(res.data?.data || []);
    } catch (e) {
      toast.error(e?.response?.data?.message || e.message || "Failed to load FAQs");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFaqs();
  }, []);

  const deactivateTopic = async (slug) => {
    if (!window.confirm("Deactivate this topic and all questions?")) return;
    try {
      await api.delete(`/admin/faqs/topic/${slug}`);
      toast.success("Topic deactivated");
      fetchFaqs();
    } catch (e) {
      toast.error(e?.response?.data?.message || e.message || "Failed");
    }
  };

  const deleteTopic = async (slug) => {
    if (!window.confirm("Permanently delete this topic and all its questions? This cannot be undone.")) return;
    try {
      await api.delete(`/admin/faqs/topic/${slug}/hard`);
      toast.success("Topic deleted");
      fetchFaqs();
    } catch (e) {
      toast.error(e?.response?.data?.message || e.message || "Failed");
    }
  };

  return (
    <div>
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
        <div>
          <h1 className="text-2xl font-bold">FAQs</h1>
          <p className="text-sm text-gray-600 mt-1">Topics with multiple Q&A </p>
        </div>

        <button
          className="rounded-xl bg-black px-4 py-2 text-white text-sm font-semibold hover:opacity-90 self-start"
          onClick={() => navigate("/admin/faqs/create")}
        >
          + Create Topic
        </button>
      </div>

      <div className="mt-6">
        {loading ? (
          <div className="text-sm text-gray-600">Loading...</div>
        ) : topics.length === 0 ? (
          <div className="text-sm text-gray-600">No FAQ topics found.</div>
        ) : (
          <div className="space-y-6">
            {topics.map((t) => (
              <div key={t.slug} className="border rounded-2xl overflow-hidden">
                <div className="bg-gray-50 px-4 py-3 flex flex-col sm:flex-row sm:items-center justify-between gap-2">
                  <div>
                    <div className="font-bold">{t.topic}</div>
                    <div className="text-xs text-gray-600">
                      {/* slug: <b>{t.slug}</b> • section: <b>{t.section_type}</b> • order: <b>{t.topic_order}</b> • questions: <b>{t.faqs.length}</b> */}
                      section: <b>{t.section_type}</b> • order: <b>{t.topic_order}</b> • questions: <b>{t.faqs.length}</b>
                    </div>
                  </div>

                  <div className="flex gap-2">
                    <button
                      className="rounded-lg border px-3 py-1 text-xs font-semibold hover:bg-gray-50"
                      onClick={() => navigate(`/admin/faqs/edit/${t.slug}`)}
                      type="button"
                    >
                      Edit
                    </button>

                    <button
                      className="rounded-lg border px-3 py-1 text-xs font-semibold hover:bg-gray-50"
                      onClick={() => deactivateTopic(t.slug)}
                      type="button"
                    >
                      Deactivate
                    </button>

                    <button
                      className="rounded-lg border border-red-200 text-red-600 px-3 py-1 text-xs font-semibold hover:bg-red-50"
                      onClick={() => deleteTopic(t.slug)}
                      type="button"
                    >
                      Delete
                    </button>
                  </div>
                </div>

                <div className="p-4 space-y-2">
                  {t.faqs.slice(0, 4).map((q) => (
                    <div key={q.faq_id} className="rounded-xl border px-4 py-3">
                      <div className="font-semibold">{q.question}</div>
                      <div className="text-sm text-gray-600 mt-1 line-clamp-2">{q.answer}</div>
                    </div>
                  ))}

                  {t.faqs.length > 4 ? (
                    <div className="text-xs text-gray-500">+ {t.faqs.length - 4} more questions...</div>
                  ) : null}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
